import { Routine } from 'redux-saga-routines';
import { map } from 'ramda';
import {
  setRoleRoutine,
  fetchContactRoutine,
  updateProspectStatusRoutine,
  resetRoleRoutine,
  changeCandidatePositionRoutine, saveContactInfoRoutine, resetContactIsSavedRoutine, setContactInfoErrorRoutine
} from '../../routines';
import { IContact } from '../../../../common/models/contact/IContact';
import { ContactType } from '../../../../common/enums/ContactType';
import { showContactProfileModalRoutine } from '../../../../routines/history';

export type ContactState = {
  contact: IContact;
  contactId: string;
  candidateId: string;
  role: ContactType;
  loading: boolean;
  isUpdating: boolean;
  isContactSaved: boolean;
  isSavingContact: boolean;
  contactInfoError: boolean;
};

const initialState = {} as ContactState;

export const contact = (state: ContactState = initialState, { type, payload }: Routine<any>): ContactState => {
  switch (type) {
    case setRoleRoutine.TRIGGER:
      return {
        ...state,
        contact: state.contact,
        ...payload
      };
    case resetRoleRoutine.TRIGGER:
      return { ...initialState, loading: false, contact: state.contact };
    case showContactProfileModalRoutine.TRIGGER: {
      return { ...initialState, loading: true };
    }
    case fetchContactRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchContactRoutine.SUCCESS:
      return {
        ...state,
        contact: payload,
        loading: false
      };
    case fetchContactRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case updateProspectStatusRoutine.TRIGGER:
      return {
        ...state,
        isUpdating: true
      };
    case updateProspectStatusRoutine.SUCCESS:
      const { prospect } = state.contact;
      return {
        ...state,
        contact: { ...state.contact, prospect: { ...prospect, status: payload } },
        isUpdating: false
      };
    case updateProspectStatusRoutine.FAILURE:
      return {
        ...state,
        isUpdating: false
      };
    case changeCandidatePositionRoutine.SUCCESS:
      return {
        ...state,
        contact: {
          ...state.contact,
          candidates: map(candidate => (candidate.id === payload.id
            ? { ...candidate, ...payload }
            : candidate), state.contact.candidates)
        }
      };
    case saveContactInfoRoutine.TRIGGER:
      return {
        ...state,
        isSavingContact: true
      };
    case saveContactInfoRoutine.SUCCESS:
      return {
        ...state,
        isContactSaved: true,
        isSavingContact: false,
        contact: { ...state.contact, ...payload }
      };
    case saveContactInfoRoutine.FAILURE:
      return {
        ...state,
        isSavingContact: false
      };
    case resetContactIsSavedRoutine.TRIGGER:
      return {
        ...state,
        isContactSaved: false
      };
    case setContactInfoErrorRoutine.TRIGGER:
      return {
        ...state,
        contactInfoError: payload,
        isSavingContact: false
      };
    default:
      return state;
  }
};
